export function getPercentage(value1: number, value2: number): string {
  return String(Math.round((value1 / value2) * 100));
}
